export default [
    {
        path: "/app/:userDeptRoleId/office-doc",
        components: {
            default: () => import("../views/office/doc/index.vue")
        },
        name: "office-doc"
    },
    {
        path: "/app/:userDeptRoleId/office-user",
        components: {
            default: () => import("../views/office/user/index.vue")
        },
        name: "office-user"
    },
    {
        path: "/app/:userDeptRoleId/office-user/detail/:id",
        components: {
            default: () => import("../views/office/user/index.vue"),
            detail: () => import("../views/office/user/detail.vue")
        },
        name: "office-user-detail"
    },
];



// WEBPACK FOOTER //
// ./src/router/office.js